import { useMutation } from '@tanstack/react-query';
import { readNewUrgentAlarmsApi } from 'features/alarm/api/alarm';

export default function useReadNewUrgentAlarms() {
  return useMutation({
    mutationFn: readNewUrgentAlarmsApi,
  });
}
